interface CountdownDisplayProps {
  countDownTime: number;
  captureCount: number;
  totalPhotos: number;
}

export function CountdownDisplay({ 
  captureCount, 
  totalPhotos 
}: CountdownDisplayProps) {
  return (
    <div className="text-center mt-8">
      <p className="opacity-80">
        Capturing photo {captureCount + 1} of {totalPhotos}
      </p>
    </div>
  );
}
